module.exports = __webpack_public_path__ + "static/media/bg-image-8.fa030f95.jpg";